import { FC } from 'react'
import { colors, ELanguage } from '@microfrontends/react-components'
import MainLayout from '../../containers/MainLayout'
import Event from '../../components/Event/Landing'
import { getServerSideProps } from '../../ssr/event'
import IPageProps from '../../services/models'
import { customTranslation } from '../../helpers/translation'
import { EPages } from '@microfrontends/app-shell-v2'

const EventPage: FC<IPageProps> = (props) => {
	return (
		<MainLayout
			{...props}
			metaCanonical='su-kien'
			languageCode={ELanguage.VI}
			pageName={EPages.NONE}
			metaTitle='Sự kiện'
			t={customTranslation('event', ELanguage.VI)}
			responsiveCornerColor={colors.primary[40]}
		>
			<Event {...props.data} />
		</MainLayout>
	)
}

export default EventPage

export { getServerSideProps }
